import React, { useState } from 'react'

const TableInput = ({
    label,
    initialValue,
    fieldUpdated,
    onBlur,
    type,
    disabled,
}) => {

    const [value, setValue] = useState(initialValue)

    return (
        <>
            <input
                disabled={disabled}
                type={type}
                value={value ? value : ''}
                onChange={(e) => {
                    setValue(e.target.value)
                    if (fieldUpdated) fieldUpdated(label, e.target.value)
                }}
                onBlur={() => {
                    if (onBlur) onBlur(label, value)
                }}
            />
        </>
    )
}

export default TableInput